
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.8","height":"37.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"フッター　トップ","fill":"#6d6c6f"}},[_c('path',{attrs:{"d":"M14.253 22v-7.765h5.176V22H25.9V11.647h3.882L16.841 0 3.9 11.647h3.882V22z"}}),_c('text',{attrs:{"transform":"translate(.4 36.5)","stroke":"#6d6c6f","stroke-width":".4","font-size":"11","font-family":"HiraKakuProN-W3, Hiragino Kaku Gothic ProN"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('トップ')])])])])
          )
        }
      }
    